import clsx from 'clsx';
import {forwardRef, ReactNode} from 'react';

type DropdownActionContainerProps = {
    children: ReactNode;
    className?: string;
};

const DropdownActionContainer = forwardRef<
    HTMLDivElement,
    DropdownActionContainerProps
>(
    ({children, className}, ref) =>
        children && (
            <div
                className={clsx(
                    'my-2 grid w-max max-w-xs grid-cols-1 rounded border border-blue-400 bg-grey-10 p-1 drop-shadow-md',
                    className,
                )}
                ref={ref}
            >
                {children}
            </div>
        ),
);

DropdownActionContainer.displayName = 'DropdownActionContainer';

export default DropdownActionContainer;
